import { render } from "./waterAnalysis.vue?vue&type=template&id=0e24cb30&scoped=true"
import script from "./waterAnalysis.vue?vue&type=script&lang=js"
export * from "./waterAnalysis.vue?vue&type=script&lang=js"

import "./waterAnalysis.vue?vue&type=style&index=0&id=0e24cb30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e24cb30"]])

export default __exports__